exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".spouse-form{padding:2rem 0 4rem;margin-left:-1.5rem}.spouse-form h2{position:relative}.picker-wrap{padding-left:1.5rem;margin-top:1.5rem}.clear-button{display:inline-block;background-color:#999;color:#fff;-webkit-appearance:none;border:0;line-height:1;font-size:.7rem;border-radius:10px;width:20px;height:20px;position:absolute;left:-.5em;top:.5em;transition:background-color .1s ease,opacity .1s ease,visibility .1s ease}.clear-button:hover{background-color:#f26673}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-11f75e96!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/SpouseForm.vue
// module id = 261
// module chunks = 0